import type { PartialBlock } from '@/types';
import { snapshot, getVersion } from 'valtio';

/**
 * clonePageBlocks
 *
 * Valtio プロキシ配列を含むページブロックをプレーンな JSON に変換した上で
 * ディープコピーを返すユーティリティ。
 *
 * - snapshot() でプロキシを解除
 * - JSON シリアライズで追加の参照を除去
 * - 失敗時はフォールバックして可能な限り配列を複製
 */
export const clonePageBlocks = (blocks: unknown): PartialBlock[] => {
  if (!Array.isArray(blocks)) {
    return [];
  }

  const cloneBlock = (block: PartialBlock): PartialBlock => {
    try {
      if (typeof structuredClone === 'function') {
        return structuredClone(block) as PartialBlock;
      }
    } catch {
      // fall through to JSON cloning
    }

    try {
      return JSON.parse(JSON.stringify(block)) as PartialBlock;
    } catch {
      return block;
    }
  };

  const rawArray = getVersion(blocks) ? (snapshot(blocks as object) as PartialBlock[]) : (blocks as PartialBlock[]);

  return rawArray.map((block) => {
    if (!block || typeof block !== 'object') {
      return block as PartialBlock;
    }
    if (getVersion(block)) {
      const plainBlock = snapshot(block as object) as PartialBlock;
      return cloneBlock(plainBlock);
    }
    return cloneBlock(block as PartialBlock);
  });
};

export default clonePageBlocks;
